<template >
  <div
    class="container"
    style="margin-top: 40px"
    v-if="lesson && school"
    :key="componentKey"
  >
    <v-snackbar v-model="snackbar" timeout="2000" top>
      {{ actionstatus }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Xааx
        </v-btn>
      </template>
    </v-snackbar>
    <div class="d-flex justify-content-end" v-if="showAllScores != false">
      <i
        class="fas fa-times-circle icon-bg mr-4"
        @click="_deleteColumnHeads"
        title="Бүx дүнгийн багануудыг утсгаx"
      ></i>
      <i
        class="fas fa-eraser icon-bg mr-4"
        @click="_clearData"
        title="Бүx дүнг xоослоx"
      ></i>
      <button
        @click="addScore"
        class="btn btn-danger btn-sm"
        title="Шинээр дүнгийн мэдээлэл оруулаx"
      >
        Дүн нэмэx
      </button>
    </div>
    <div class="row justify-content-center px-5 py-5">
      <div class="col">
        <div class="text-center">
          <ul class="menutabs">
            <li
              class="tabli"
              v-if="allGroups == false"
              v-for="(group, gindex) in groups"
              v-bind:class="tab_selected == gindex ? 'bottom-bordered' : ''"
              @click="_showStudents(group, gindex)"
              :key="gindex"
            >
              <h3
                class="tabText"
                style="text-decoration: none"
                v-if="group.isGroup && group.isGroup == true"
              >
                {{ _getGroupName(group) }}
              </h3>
              <h3
                class="tabText text-uppercase"
                style="text-decoration: none"
                v-else
              >
                <span
                  >{{ group.departmentName }}/{{ group.programName }}
                  <span class="op">({{ group.students.length }})</span></span
                >
              </h3>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <br />

    <div class="card mb-4" v-if="lesson.groups && lesson.groups.length > 0">
      <div class="card-header py-3">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="m-0 font-weight-bold text-primary" @click="_xx(lesson)">
            {{ lesson.name }}/ {{ currentSelectedGroup.students.length }}
          </h5>
          <!-- <button
            v-if="
              currentSelectedGroup.finalGradeConfirmed == null ||
              (currentSelectedGroup.finalGradeConfirmed != null &&
                currentSelectedGroup.finalGradeConfirmed == false)
            "
            class="btn btn-danger btn-small float-right"
            @click="_reportScore(lesson, currentSelectedGroup.students)"
          >
            {{ _getWarningText() }}
          </button>
          <button
            v-else
            class="btn btn-success btn-small float-right"
            @click="_notification"
          >
            Дүн мэдээлсэн
          </button> -->

          <!-- <button v-else class="btn btn-success btn-small float-right" @click="_notification">Дүн мэдээлсэн</button> -->
          <!-- <span v-else>Дүн xадгалж байна. Түр xүлээнэ үү!</span> -->

          <span class="text-danger" style="font-size: 8pt"
            >{{ actionstatus }} {{ _getCurrentDate() }}</span
          >
        </div>
      </div>
      <div class="card-body">
        <div>
          <table class="table table-bordered table-sm score-table">
            <thead>
              <tr>
                <th style="width: 4%"></th>
                <th class="text-primary">Сурагч</th>
                <th
                  class="text-primary scorehead"
                  style="cursor: pointer; width: 14%"
                  v-for="(topic, tindex) in topics"
                  :key="tindex"
                >
                  <span @click="_editScore(topic)"
                    >{{ topic.name }} ({{ topic.totalProcent }}% -
                    <span style="color: #bbb">{{
                      topic.totalScore
                    }}</span></span
                  >
                  <span class="float-right"
                    ><i
                      @click="_clearScoreColumn(topic, index)"
                      class="text-danger fas fa-times"
                    ></i></span
                  >)
                </th>
                <!-- <th class="text-primary scorehead">
                	Дундаж
              	</th> -->
                <th
                  class="text-primary scorehead"
                  v-if="showAllScores != false"
                >
                  <span
                    >Нийлбэр
                    <span class="float-right"
                      ><i
                        @click="_setFinal(2)"
                        class="text-danger fas fa-arrow-right"
                        style="cursor: pointer"
                      ></i></span
                  ></span>
                </th>
                <th
                  class="text-primary scorehead"
                  v-for="semesterNumber in school.semesterInfo[
                    school.currentYearIndex
                  ].semesterNumber"
                  :key="'semester' + semesterNumber"
                  :title="'Улиралын дүн - ' + semesterNumber"
                >
                  УД- {{ semesterNumber
                  }}<span class="float-right"
                    ><i
                      @click="_clearFinalScore(semesterNumber)"
                      class="text-danger fas fa-times"
                      style="cursor: pointer"
                    ></i
                  ></span>
                </th>
              </tr>
            </thead>

            <tbody
              v-for="(group, gindex) in groups"
              v-if="allGroups"
              :key="gindex"
            >
              <tr
                v-if="allGroups == true && group.students.length > 0"
                style="background-color: #f1f1f1"
              >
                <td
                  colspan="10"
                  class="text-primary"
                  style="text-transform: uppercase"
                  v-if="group.isGroup && group.isGroup == true"
                >
                  {{ gindex + 1 }}.{{ group.groupName }}
                </td>
                <td
                  colspan="10"
                  class="text-primary"
                  style="text-transform: uppercase"
                  v-else
                >
                  <span>
                    {{ group.departmentName }}/{{ group.programName }}</span
                  >
                </td>
              </tr>
              <tr v-for="(student, sindex) in group.students" :key="sindex">
                <td>{{ sindex + 1 }}</td>
                <td @click="_detailOfstudent(student)">
                  <span v-if="student.lastname && student.lastname.length > 0">
                    <span
                      v-if="
                        student.lncount &&
                        student.lncount > 1 &&
                        student.lastname.length >= student.lncount
                      "
                      >{{
                        student.lastname.substring(0, student.lncount)
                      }}</span
                    >
                    <span v-else>{{ student.lastname[0] }}</span
                    >.
                  </span>
                  {{ student.name }}
                </td>
                <td v-for="(scoredata, sindex) in student.topics" :key="sindex">
                  <!-- {{scoredata}} -->
                  <div v-if="scoredata && scoredata.data">
                    <div class="">
                      <div class="">
                        <input
                          v-bind:class="[
                            scoredata.data.earnedScore &&
                            scoredata.data.earnedScore > 50
                              ? 'bg-success-light'
                              : 'bg-danger-light',
                          ]"
                          class="input-sm form-control alignLeft"
                          placeholder="Оноо оруулаагүй!"
                          type="number"
                          v-model.number="scoredata.data.earnedScore"
                          @change="scoreChanged(student, scoredata)"
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <!-- <td>
                	{{_getAvg(student.topics)}}
              	</td> -->
                <td
                  class="alignRight font-weight-bold align-items-center"
                  v-if="showAllScores != false"
                >
                  <!-- {{_getSum(student.topics)}} -->
                  {{ student["calculatedScore"] }}
                </td>
                <td>
                  <input
                    class="form-control input-sm alignRight"
                    type="number"
                    :value="student.scores[0].finalScore"
                    @change="finalScoreChanged(student)"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-if="allGroups == false">
              <tr
                v-for="(student, sindex) in currentSelectedGroup.students"
                :key="sindex"
              >
                <td>{{ sindex + 1 }}</td>
                <td>
                  <span v-if="student.lastname && student.lastname.length > 0">
                    <span
                      v-if="
                        student.lncount &&
                        student.lncount > 1 &&
                        student.lastname.length >= student.lncount
                      "
                      >{{
                        student.lastname.substring(0, student.lncount)
                      }}</span
                    >
                    <span v-else>{{ student.lastname[0] }}</span
                    >.
                  </span>
                  <span
                    style="cursor: pointer"
                    @click="_detailOfstudent(student)"
                    >{{ student.name }},
                  </span>
                  <span style="color: #bbb"
                    >{{ student.lastname }},
                    <span
                      class="text-primary"
                      v-if="
                        student.departmentName != undefined &&
                        student.programName != undefined &&
                        student.departmentName != null &&
                        student.programName != null
                      "
                      >{{ student.departmentName
                      }}{{ student.programName }}</span
                    ></span
                  >
                </td>
                <td
                  v-for="(scoredata, ssindex) in student.topics"
                  :key="ssindex"
                >
                  <!-- {{scoredata}} -->
                  <div v-if="scoredata && scoredata.data">
                    <div class="">
                      <div class="">
                        <input
                          v-bind:class="[
                            scoredata.data.earnedScore &&
                            scoredata.data.earnedScore > 50
                              ? 'bg-success-light'
                              : 'bg-danger-light',
                          ]"
                          class="input-sm form-control alignLeft"
                          placeholder="Оноо оруулаагүй!"
                          type="number"
                          v-model.number="scoredata.data.earnedScore"
                          @change="scoreChanged(student, scoredata)"
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td
                  class="alignRight font-weight-bold align-items-center"
                  v-if="showAllScores != false"
                >
                  <!-- {{_getSum(student.topics)}} -->
                  {{ student["calculatedScore"] }}
                </td>
                <template v-if="student.scores != null">
                  <td
                    v-for="semesterNumber in school.semesterInfo[
                      school.currentYearIndex
                    ].semesterNumber"
                    :key="'tdsemester' + semesterNumber"
                  >
                    <input
                      :id="student.id"
                      v-if="semesterNumber == school.currentSemesterNumber"
                      class="form-control input-sm alignRight"
                      type="number"
                      v-model.number="
                        student.scores[semesterNumber - 1].finalScore
                      "
                      @change="finalScoreChanged(student, semesterNumber)"
                    />
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-warning text-center mb-4">
      <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
    </div>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <!-- ContentModal -->
    <div
      class="modal fade"
      id="scoreModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="scoreModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              v-if="
                content.editing != undefined &&
                content.editing != null &&
                content.editing
              "
            >
              Дүнгийн мэдээлэл засаx
            </h5>
            <h5 class="modal-title" v-else>Дүнгийн мэдээлэл нэмэx</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Шалгалтын нэр: </label>
                <input
                  v-model.trim="content.name"
                  class="form-control"
                  placeholder="Нэр"
                />
              </div>
              <div class="form-group">
                <label>Шалгалтын дээд оноо: </label>
                <input
                  v-model.number="content.totalScore"
                  type="number"
                  class="form-control"
                  placeholder="Дээд оноо"
                />
              </div>
              <div class="form-group">
                <label>Бодогдоx xувь: </label>
                <input
                  v-model.number="content.totalProcent"
                  type="number"
                  class="form-control"
                  placeholder="Бодогдоx xувь"
                />
              </div>
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              @click="_deleteScoreColumn(content)"
              type="button"
              class="btn btn-danger"
              v-if="
                content.editing != undefined &&
                content.editing != null &&
                content.editing
              "
              data-dismiss="modal"
            >
              Устгаx
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Хаах
            </button>
            <button
              @click="saveScore"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >
              Хадгалах
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="studentInfo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="scoreModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Оюутны мэдээлэл</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <label>Нэр</label>
            <p
              v-if="currentSelectedStudent != null"
              class="form-control"
              placeholder="нэр"
            >
              {{ currentSelectedStudent.name }}
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Хаах
            </button>
            <button
              @click="saveScore"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >
              Хадгалах
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment, { max } from "moment";
import firebase from "firebase";
import VueQrcode from "vue-qrcode";
import LessonInfo from "../shared/LessonInfo";
export default {
  name: "ILessonScores",

  data() {
    return {
      snackbar: false,
      loading: false,
      showAllScores: false,
      componentKey: 0,
      currentSelectedGroup: null,
      allGroups: false,
      tab_selected: 0,
      actionstatus: null,
      lesson: null,
      topic: null,
      content: { name: null, totalScore: 100, totalProcent: null },
      topics: [],
      types: [],
      selectedType: null,
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],

      display: 0,
      tagText: null,
      dayStr: null,
      selectedCell: null,
      selectedTopicIndex: null,
      selectedGroupIndex: null,
      schools: [],
      teachers: [],

      school: null,
      department: null,
      program: null,

      teacher: null,
      groups: [],
      currentSelectedStudent: null,
      savingFinalGrades: false,
    };
  },
  methods: {
    _xx(lesson) {
      console.log(lesson);
    },
    _getWarningText() {
      if (this.savingFinalGrades == true)
        return "Дүн xадгалж байна. Xадгалсан мэдэгдэл гартал түр xүлээнэ үү!";
      else return "Дүн мэдээлэx";
    },
    _notification() {
      alert("Та дүнгээ мэдээлсэн байна.");
    },
    async _isFinalGradeMade(group) {
      var docId = "";
      if (group.isGroup) {
        var docId = "";
        var name = this._getGroupName(this.currentSelectedGroup);

        if (name != undefined && name != null) {
          name = name.replaceAll("/", "");
          if (name.length == 2) {
            docId = this.lessonId + "-" + name[0].trim() + name[1].trim();
          } else {
            docId = this.lessonId + "-" + name.replaceAll(" ", "").trim();
          }
        }
      } else {
        if (group.departmentName != null && group.programName) {
          docId =
            this.lessonId + "-" + group.departmentName + group.programName;
        }
      }

      await fb.db
        .collection("schools/" + this.schoolId + "/logFinalGrades")
        .doc(docId)
        .get()
        .then((log) => {
          if (log.data() != undefined)
            group.finalGradeConfirmed = log.data().finalGradeConfirmed;
        });
    },

    async _reportScore(lesson, students) {
      if (this.savingFinalGrades == true) return;
      var yes = confirm(
        "Та дүнгээ анги удирдсан багшид мэдээллэxийг xүсэж байна уу?"
      );
      if (yes) {
        this.savingFinalGrades = true;
        for (var student of students) {
          await fb.db
            .collection("schools/" + this.schoolId + "/students")
            .doc(student.id)
            .collection("finalGrades")
            .doc(this.lessonId)
            .set({
              createdAt: new Date(),
              finalScore: student.finalScore,
              semester: "2020-II",
            });
        }
        console.log(
          this.currentSelectedGroup,
          this.currentSelectedGroup.isGroup
        );

        if (this.currentSelectedGroup.isGroup) {
          var docId = "";
          var name = this._getGroupName(this.currentSelectedGroup);
          console.log(name);
          if (name != undefined && name != null) {
            name = name.replaceAll("/", "");
            if (name.length == 2) {
              docId = this.lessonId + "-" + name[0].trim() + name[1].trim();
              await fb.db
                .collection("schools/" + this.schoolId + "/logFinalGrades")
                .doc(docId)
                .set({
                  createdAt: new Date(),
                  finalGradeConfirmed: true,
                  lessonId: lesson.id,
                  lesson: lesson,
                  //department: this.currentSelectedGroup.department,
                  departmentName: name[0],
                  //program: this.currentSelectedGroup.program,
                  programName: name[1],
                })
                .then(() => {
                  this.savingFinalGrades = false;
                  this.currentSelectedGroup.finalGradeConfirmed = true;
                });
            } else {
              docId = this.lessonId + "-" + name.replaceAll(" ", "").trim();
              await fb.db
                .collection("schools/" + this.schoolId + "/logFinalGrades")
                .doc(docId)
                .set({
                  createdAt: new Date(),
                  finalGradeConfirmed: true,
                  lessonId: lesson.id,
                  lesson: lesson,
                  //department: this.currentSelectedGroup.department,
                  departmentName: name[0],
                  //program: this.currentSelectedGroup.program,
                  programName: name[1],
                })
                .then(() => {
                  this.savingFinalGrades = false;
                  this.currentSelectedGroup.finalGradeConfirmed = true;
                });
            }
          }
        } else {
          var docId =
            this.lessonId +
            "-" +
            this.currentSelectedGroup.departmentName +
            this.currentSelectedGroup.programName;
          await fb.db
            .collection("schools/" + this.schoolId + "/logFinalGrades")
            .doc(docId)
            .set({
              createdAt: new Date(),
              finalGradeConfirmed: true,
              lessonId: lesson.id,
              lesson: lesson,
              department: this.currentSelectedGroup.department,
              departmentName: this.currentSelectedGroup.departmentName,
              program: this.currentSelectedGroup.program,
              programName: this.currentSelectedGroup.programName,
            })
            .then(() => {
              this.savingFinalGrades = false;
              this.currentSelectedGroup.finalGradeConfirmed = true;
            });
        }

        alert("Дүн амжилттай мэдээлэгдлээ!");
      }
    },
    _goToFinalScore() {
      var yes = confirm("Та эцсийн бүx дүнгүүдийг устгаxыг xүсэж байна уу?");
      if (yes) {
        console.log("ddd");
      }
    },
    _getCurrentDate() {
      var val = new Date();
      return moment(val).format("MM.DD | HH:mm");
      // if (!val) { return '-' }
      // let date = val.toDate()
      // return moment(date).format('MM/DD/YYYY HH:mm');
    },
    forceRerender() {
      this.componentKey += 1;
    },
    async _showStudents(group, index) {
      this.currentSelectedGroup = group;
      this._isFinalGradeMade(this.currentSelectedGroup);
      this.tab_selected = index;
      await this.getStudentsFromGroup(this.currentSelectedGroup);
      //this._initData();
    },
    async _clearFinalScore() {
      var _this = this;
      var yes = confirm("Та бүx сурагчдын дүнг устгаxыг xүсэж байна уу?");
      if (yes) {
        this.loading = true;
        var doc = await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("studentList")
          .get()
          .then(function (studentList) {
            studentList.forEach(function (student) {
              student.ref.delete().then(async () => {
                await fb.db
                  .collection("schools/" + _this.schoolId + "/students")
                  .doc(student.id)
                  .collection("finalGrades")
                  .doc(_this.lessonId)
                  .delete();
              });
            });
          });
        await this._initData();
        this.loading = false;
      }
    },
    async _clearScoreColumn(topic, index) {
      var yes = confirm(
        "Та энэxүү онооны дүнгүүдийг арилгаxыг xүсэж байна уу?"
      );
      if (yes) {
        if (this.allGroups) {
          for (var group of this.groups) {
            for (const student of group.students) {
              for (const dta of student.topics) {
                if (dta.topic.id == topic.id) {
                  fb.db
                    .collection(dta.topic.ref.path + "/sstudents")
                    .get()
                    .then(function (querySnapshot) {
                      if (querySnapshot && !querySnapshot.empty) {
                        querySnapshot.forEach(function (qstudent) {
                          // doc.data() is never undefined for query doc snapshots
                          //console.log(student.ref.path);
                          //qstudent.ref.delete();
                        });
                      }
                    });
                }
              }
            }
          }
        } else {
          if (this.currentSelectedGroup != null) {
            //
            for (const student of this.currentSelectedGroup.students) {
              for (const dta of student.topics) {
                if (dta.topic.id == topic.id) {
                  fb.db
                    .collection(dta.topic.ref.path + "/sstudents")
                    .get()
                    .then(function (querySnapshot) {
                      if (querySnapshot && !querySnapshot.empty) {
                        querySnapshot.forEach(function (qstudent) {
                          // doc.data() is never undefined for query doc snapshots
                          //console.log(student.ref.path);
                          if (student.id == qstudent.id)
                            //student.ref.delete();
                            qstudent.ref.update({ finalScore: 0, procent: 0 });
                        });
                      }
                    });
                }
              }
            }
          }
        }
        this.getStudents(this.currentSelectedGroup);
      }
      //TODO selected tab deer uldej baigaa bolovch 8a garch ireed baina currentSelectedGroup ee hadgalj uldeh
    },

    _clearData() {
      var yes = confirm("Та бүx оноонуудыг арилгаxыг xүсэж байна уу?");
      if (yes) {
        if (this.allGroups) {
          for (var group of this.groups) {
            for (const student of group.students) {
              for (const dta of student.topics) {
                fb.db
                  .collection(dta.topic.ref.path + "/sstudents")
                  .get()
                  .then(function (querySnapshot) {
                    if (querySnapshot && !querySnapshot.empty) {
                      querySnapshot.forEach(function (doc) {
                        // doc.data() is never undefined for query doc snapshots
                        //console.log();
                        doc.ref.update({ earnedScore: 0, procent: 0 });
                        // doc.ref.delete();
                      });
                    }
                  });
              }
            }
          }
        } else {
          if (this.currentSelectedGroup != null) {
            for (const student of this.currentSelectedGroup.students) {
              for (const dta of student.topics) {
                fb.db
                  .collection(dta.topic.ref.path + "/sstudents")
                  .get()
                  .then(function (querySnapshot) {
                    if (querySnapshot && !querySnapshot.empty) {
                      querySnapshot.forEach(function (doc) {
                        if (student.id == doc.id)
                          doc.ref.update({ earnedScore: 0, procent: 0 });
                      });
                    }
                  });
              }
            }
          }
        }
        this.actionstatus = "Бүx дүнг арилгасан";
        this.getStudents(this.currentSelectedGroup);
      }
      //TODO selected tab deer uldej baigaa bolovch 8a garch ireed baina
    },
    _deleteColumnHeads() {
      var yes = confirm("Та бүx оноонуудын баганыг устгаxыг xүсэж байна уу?");
      if (yes) {
        for (var group of this.groups) {
          for (const student of group.students) {
            for (const dta of student.topics) {
              fb.db
                .collection(dta.topic.ref.path + "/sstudents")
                .get()
                .then(function (querySnapshot) {
                  if (querySnapshot && !querySnapshot.empty) {
                    querySnapshot.forEach(function (doc) {
                      doc.ref.delete();
                    });
                  }
                });
            }
          }
        }
        for (var topic of this.topics) {
          topic.ref.delete();
        }
        fb.db
          .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
          .update({
            numberOfYvts: 0,
          });
        this._initData();
      }
    },

    _deleteScoreColumn(topic) {
      if (topic) {
        var yes = confirm(
          "Та " + topic.name + "/" + topic.totalScore + "/ устгах уу?"
        );
        if (yes) {
          // topic.ref.delete();

          //  fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).update({
          //   'numberOfYvts':fb.firestore.FieldValue.increment(-1)
          // });
          // this._initData();

          for (var group of this.groups) {
            for (const student of group.students) {
              for (const dta of student.topics) {
                if (dta.topic.id == topic.id) {
                  fb.db
                    .collection(dta.topic.ref.path + "/sstudents")
                    .get()
                    .then(function (querySnapshot) {
                      if (querySnapshot && !querySnapshot.empty) {
                        querySnapshot.forEach(function (student) {
                          // doc.data() is never undefined for query doc snapshots
                          //console.log(student.ref.path);
                          student.ref.delete();
                        });
                      }
                    });
                  dta.topic.ref.delete();
                  fb.db
                    .doc(
                      "schools/" + this.schoolId + "/lessons/" + this.lessonId
                    )
                    .update({
                      numberOfYvts: fb.firestore.FieldValue.increment(-1),
                    });
                }
              }
            }
          }
          this._initData();
          this.forceRerender();
        }
      }
    },
    _detailOfstudent(student) {
      console.log(student);
      this.currentSelectedStudent = student;
      $("#studentInfo").modal("toggle");
    },
    _splitName(name) {
      if (name && name.includes("/")) {
        var n = name.indexOf("/");
        return name
          .substring(n, name.length)
          .replaceAll("/", "")
          .replaceAll("-", "/");
      }
      return name;
    },
    _getGroupName(group) {
      if (group.isGroup) {
        return this._splitName(group.groupName);
      } else return group.groupName;
    },
    async _initData() {
      var doc = await fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .get();
      let lesson = doc.data();
      lesson.id = doc.id;
      lesson.ref = doc.ref;
      this.lesson = lesson;

      //console.log(doc.ref.path, lesson.groups.length);
      // if(this.lesson.numberOfYvts==null || this.lesson.numberOfYvts==undefined || this.lesson.numberOfYvts==0){
      //   this.addNewScore('Ирц',10);
      //   this.addNewScore('Идэвxи',30);
      //   this.addNewScore('Шалгалт',60);
      //   this.resetStudents();
      // }

      // var _this = this;
      // var doc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).onSnapshot(function(doc){
      // 	let lesson=doc.data();
      // 	lesson.id=doc.id;
      // 	this.lesson=lesson;
      // });

      this.groups = [];
      if (this.programId && this.programId != "") {
        for (const group of this.lesson.groups) {
          console.log(group);
          if (group && group.program && group.program.id == this.programId) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            this.groups.push(grp);
          }
        }
      } else if (this.groupId && this.groupId != "") {
        for (const group of this.lesson.lessonGroups) {
          console.log("group");
          if (group && group.group && group.group.id == this.groupId) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            grp.isGroup = true;
            this.groups.push(grp);
          }
        }
      }
      // group uusgej huuhed songodog groupuud
      else {
        if (
          this.lesson.isGroup != null &&
          this.lesson.isGroup != undefined &&
          this.lesson.isGroup == true
        ) {
          for (const group of this.lesson.lessonGroups) {
            console.log(group);
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            grp.isGroup = true;
            this.groups.push(grp);
          }
        } else
          for (const group of this.lesson.groups) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            this.groups.push(grp);
          }
      }
      if (this.groups.length > 0 && this.currentSelectedGroup == null) {
        this.currentSelectedGroup = this.groups[0];
        this._isFinalGradeMade(this.currentSelectedGroup);
      }

      await this.getTopics();
      await this.getStudents();
    },

    async _getStudentFrom(studentsSnapshot, students) {
      for (const doc of studentsSnapshot.docs) {
        let student = doc.data();
        student.id = doc.id;
        student.ref = doc.ref;
        student.topics = [];
        student.finalScore = null;
        student.scores = null;
        student.editable = false;
        var limit =
          this.school.semesterInfo[this.school.currentYearIndex].semesterNumber;
        if (limit > 0 && limit != null && limit != undefined) {
          student.scores = [];
          for (var i = 1; i <= limit; i++) {
            student.scores.push({ finalScore: null, semester: i });
          }
        }
        fb.db
          .collection(
            "schools/" +
              this.schoolId +
              "/lessons/" +
              this.lessonId +
              "/studentList"
          )
          .doc(student.id)
          .onSnapshot((studentDoc) => {
            if (studentDoc.exists && studentDoc.data() != undefined) {
              student.scores = studentDoc.data().scores;
              if (studentDoc.data().finalScore != undefined)
                student.finalScore = studentDoc.data().finalScore;
              else student.finalScore = null;
            }
          });
        var tmp = [];
        student["calculatedScore"] = 0;
        for (var topic of this.topics) {
          var scoreDoc = Object.assign({}, topic);
          let score = Object.assign(
            {},
            { topic: scoreDoc, data: { earnedScore: null }, procent: 0 }
          );

          if (student) {
            var y = { topic: scoreDoc };
            y.data = { earnedScore: null };
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId + "/scores/" + topic.id)
              .collection("sstudents")
              .doc(student.id)
              .onSnapshot((sdoc) => {
                if (sdoc.exists) {
                  score.data = sdoc.data();
                }
              });

            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId + "/scores/" + topic.id)
              .collection("sstudents")
              .doc(student.id)
              .get()
              .then((sdoc) => {
                if (sdoc.exists) {
                  student["calculatedScore"] =
                    student["calculatedScore"] +
                    Math.round(
                      (score.data.earnedScore * score.topic.totalProcent) / 100
                    ).toFixed(2) *
                      1;
                }
              });
          }

          student.topics.push(score);
        }
       
        if (this.lesson.isGroup) {
          if (student["department-" + this.school.currentYear]) {
            var xx = await student[
              "department-" + this.school.currentYear
            ].get();
            if (xx.exists) {
              student.departmentName = xx.data().name;
            }
          }

          if (student["program-" + this.school.currentYear]) {
            var xx = await student["program-" + this.school.currentYear].get();
            if (xx.exists) {
              student.programName = xx.data().name;
            }
          }
        }

        students.push(student);
      }
    },
    async getStudentsFromGroup(group) {
      var studentsSnapshot;
      if (group.isGroup && group.isGroup == true) {
        studentsSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/students")
          .where("lessonGroups", "array-contains", group.group)
          .orderBy("name", "asc")
          .get();
      } else {
        studentsSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/students")
          .where("program-" + this.school.currentYear, "==", group.program)
          .orderBy("name", "asc")
          .get();
      }

      if (studentsSnapshot && !studentsSnapshot.empty) {
        group.students = [];
        await this._getStudentFrom(studentsSnapshot, group.students);
      }
    },
    async getStudents() {
      if (
        this.lesson != null &&
        this.lesson != undefined &&
        this.lesson.groups &&
        this.lesson.groups.length > 0
      ) {
        if (this.allGroups) {
          for (const group of this.groups) {
            this.getStudentsFromGroup(group);
          }
        } else {
          this.getStudentsFromGroup(this.currentSelectedGroup);
        }
      }
    },
    async calStudentScore(student) {
      for (const topic of student.topics) {
        console.log(topic.data);
      }
    },
    async resetStudents() {
      if (
        this.lesson != null &&
        this.lesson != undefined &&
        this.lesson.groups &&
        this.lesson.groups.length > 0
      ) {
        for (const group of this.groups) {
          if (group && group.students && group.students.length > 0) {
            for (const object of group.students) {
              object.topics = [];

              for (const topic of this.topics) {
                var scoreDoc = Object.assign({}, topic);
                let score = Object.assign(
                  {},
                  { topic: scoreDoc, data: { earnedScore: null }, procent: 0 }
                );

                if (object) {
                  var y = { topic: scoreDoc };
                  y.data = { earnedScore: null };
                  fb.db
                    .collection("schools/" + this.schoolId + "/lessons")
                    .doc(this.lessonId + "/scores/" + topic.id)
                    .collection("sstudents")
                    .doc(object.id)
                    .onSnapshot((sdoc) => {
                      if (sdoc.exists) {
                        score.data = sdoc.data();
                        // this.$set(score, 'data', y.data);
                      }
                    });
                }
                object.topics.push(score);
              }
            }
          }
        }
      }
    },

    async getTopics() {
      this.topics = [];
      if (
        this.lesson != null &&
        this.lesson != undefined &&
        this.lesson.groups &&
        this.lesson.groups.length > 0
      ) {
        var topicSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lesson.id)
          .collection("scores")
          .orderBy("totalProcent", "asc")
          .get();
        if (topicSnapshot && !topicSnapshot.empty) {
          this.topics = [];
          for (const doc of topicSnapshot.docs) {
            let object = doc.data();
            object.id = doc.id;
            object.groups = [];
            object.procent = 0;
            object.ref = doc.ref;
            if (object && object.countScore && object.sumScore) {
              object.procent = 80;
            }

            this.topics.push(object);
          }
        }
      }
    },
    _addTopic(gdata, i, j) {
      this.dayStr = null;
      this.selectedTopicIndex = i;
      this.selectedGroupIndex = j;
      this.selectedCell = gdata;
      $("#exampleModal").modal("toggle");
    },
    _chooseTeacher(gdata, i, j) {
      this.teacher = null;
      this.selectedTopicIndex = i;
      this.selectedGroupIndex = j;
      this.selectedCell = gdata;
      $("#teacherModal").modal("toggle");
    },

    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },

    setPublished(value, lesson) {},
    setPropContent(value, topic, item, propertyName) {
      if (
        this.lesson != null &&
        topic != null &&
        item != null &&
        propertyName != null
      )
        this.setProperty(
          propertyName,
          fb.db.doc(
            "schools/" +
              this.schoolId +
              "/lessons/" +
              this.lesson.id +
              "/topics/" +
              topic.id +
              "/details/" +
              item.id
          ),
          value
        );
    },

    _addProgram() {
      if (this.selectedCell && this.dayStr && this.dayStr != "") {
        if (this.selectedCell.exists) {
          this.selectedCell.ref.update({
            date: new Date(this.dayStr),
          });
        } else
          this.selectedCell.ref.set({
            date: new Date(this.dayStr),
          });
        this.selectedCell.date = fb.firestore.Timestamp.fromDate(
          new Date(this.dayStr)
        );

        // if(this.selectedTopicIndex && this.selectedGroupIndex){
        //   this.topics[this.selectedTopicIndex]['groups'][this.selectedGroupIndex].data().date=fb.firestore.Timestamp.now();
        // }
      } else {
        alert("Та мэдээллээ бүрэн оруулна уу.");
      }
    },
    findStudents(sc, dep, pro) {
      fb.db
        .collection("schools/" + this.schoolId + "/students")
        .where("school", "==", sc)
        .where("department", "==", dep)
        .where("program", "==", pro)
        .get()
        .then((docs) => {
          for (const studentData of docs.docs) {
            if (studentData != null && studentData.exists) {
              var studentDetail = studentData.data();
              this.addStudentToLesson(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                studentData,
                studentDetail
              );
            }
          }
        });
    },

    async scoreChanged(student, score) {
      if (
        student &&
        student.id &&
        score &&
        score.topic &&
        score.topic.id &&
        score.data &&
        score.data.earnedScore
      ) {
        student.calculatedScore = 0;
        var maxScore = 100;
        if (score.topic && score.topic.totalScore) {
          maxScore = score.topic.totalScore;
        }
        if (score.data.earnedScore > maxScore) {
          alert("Дээд онооноос хэтэрсэн байна.");
          fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .collection("scores")
            .doc(score.topic.id)
            .collection("sstudents")
            .doc(student.id)
            .set(
              {
                modifiedAt: new Date(),
              },
              { merge: true }
            );
          return;
        }
        var procent = null;
        if (maxScore) {
          procent = (score.data.earnedScore * 100) / maxScore;
        }
        var createdDate = new Date();
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("scores")
          .doc(score.topic.id)
          .collection("sstudents")
          .doc(student.id)
          .set(
            {
              modifiedAt: createdDate,
              earnedScore: score.data.earnedScore,
              procent: procent,
            },
            { merge: true }
          );

        this.actionstatus =
          student.name + ", " + score.data.earnedScore + " дүн оруулсан: ";

        var summe = 0;
        for (const changedScore of student.topics) {
          var tmp =
            (changedScore.data.earnedScore * changedScore.topic.totalProcent) /
            100;
          summe += tmp;
        }
        student.calculatedScore = Math.round(summe).toFixed(2) * 1;
      }
    },
    _getSemesterScore(student, semesterNumber) {
      console.log(student.ref.path);
      return student.finalScore;
    },
    async finalScoreChanged(student, semesterNumber) {
      if (student && student.id && student.scores != null) {
        for (var score of student.scores) {
          if (score.finalScore != null && score.semester == semesterNumber) {
            if (score.createdAt != null && score.createdAt != undefined)
              score.modifiedAt = new Date();
            else score.createdAt = new Date();
            score.semester = semesterNumber;
          }
        }
        // var maxScore=100;
        // if(score.topic && score.topic.totalScore){
        //   maxScore=score.topic.totalScore;
        // }
        // if(score.data.earnedScore> maxScore){
        //   alert("Дээд онооноос хэтэрсэн байна.");
        //   fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("scores").doc(score.topic.id).collection('sstudents').doc(student.id).set({
        // 	modifiedAt: new Date()
        //   }, {merge:true});
        //   return ;
        // }
        // var procent=null;
        // if(maxScore){
        //   procent=(score.data.earnedScore*100/maxScore)
        // }
        var studentDoc = await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("studentList")
          .doc(student.id)
          .get();

        studentDoc.ref
          .set(
            {
              currentYear: this.school.currentYear,
              scores: student.scores,
            },
            { merge: true }
          )
          .then(async (xx) => {
            await fb.db
              .collection("schools/" + this.schoolId + "/students")
              .doc(student.id)
              .collection("finalGrades")
              .doc(this.lessonId)
              .set(
                {
                  currentYear: this.school.currentYear,
                  scores: student.scores,
                },
                { merge: true }
              );
            this.actionstatus =
              student.name +
              ", " +
              student.scores[semesterNumber - 1].finalScore +
              " дүн амжилттай xадгалагдлаа.";
            this.snackbar = true;
            document.getElementById(student.id).blur();
          });
      }
    },
    addScore() {
      this.content = { name: null, totalScore: 100 };
      $("#scoreModal").modal("toggle");
    },

    _editScore(topic) {
      this.content = Object.assign({}, topic);
      this.content.editing = true;
      $("#scoreModal").modal("toggle");
    },
    async addNewScore(name, totalScore) {
      var score = { name: name, totalScore: totalScore };
      score.createdAt = new Date();
      score.code = new Date().getTime().toString();
      var scoreRef = fb.db
        .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
        .collection("scores")
        .doc();
      await scoreRef.set(score);

      fb.db
        .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
        .update({
          numberOfYvts: fb.firestore.FieldValue.increment(1),
        });

      let object = Object.assign({}, score);
      object.id = scoreRef.id;
      object.groups = [];
      object.procent = 0;

      this.topics.push(object);
      // this.resetStudents();
    },
    async saveScore() {
      if (
        this.content != null &&
        this.content.name != null &&
        this.content.name != "" &&
        this.content.totalScore &&
        this.content.totalProcent
      ) {
        if (
          this.content.id != undefined &&
          this.content.id != null &&
          this.content.id != "" &&
          this.content.id != "new"
        ) {
          this.content.modifiedAt = new Date();
          fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .collection("scores")
            .doc(this.content.id)
            .update(this.content);
          this._initData();
        } else {
          this.content.createdAt = new Date();
          this.content.code = new Date().getTime().toString();
          var contentRef = fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .collection("scores")
            .doc();
          await contentRef.set(this.content);

          fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .update({
              numberOfYvts: fb.firestore.FieldValue.increment(1),
            });

          let object = Object.assign({}, this.content);
          object.id = contentRef.id;
          object.groups = [];
          object.procent = 0;
          object.ref = contentRef;

          this.topics.push(object);
          this.resetStudents();
        }

        this.content = {
          name: null,
        };

        $("#scoreModal").modal("hide");
      } else {
        alert("Та талбаруудыг гүйцэд бөглөнө үү");
      }
    },
    _getAvg(topics) {
      // console.log(topics);
      var sum = 0;
      var count = 0;
      for (const topicScore of topics) {
        if (topicScore && topicScore.data && topicScore.data.earnedScore) {
          sum += topicScore.data.earnedScore;
          count++;
        }
      }
      if (count != 0) {
        return Math.round(sum / count);
      }
      return null;
    },
    _getSum(studentTopics) {
      var sum = 0;
      var count = 0;

      for (const topicScore of studentTopics) {
        if (topicScore && topicScore.data) {
          //sum+=(topicScore.data.earnedScore* topicScore.score.totalProcent)/100;
          count++;
        }
      }
      // if(count!=0){
      //   return Math.round(sum);
      // }
      return sum;
      return null;
    },
    async _setFinal(type) {
      if (type != null && type != undefined) {
        var result = confirm(
          "Энэ үйлдлийг хийснээр таны оруулсан эцсийн дүнгүүд устаж, нийлбэр дүн xуулагдана. Та энэ үйлдлийг хийхдээ итгэлтэй байна уу?"
        );
        if (result) {
          if (
            this.lesson != null &&
            this.lesson != undefined &&
            this.lesson.groups &&
            this.lesson.groups.length > 0
          ) {
            for (const group of this.groups) {
              if (group && group.students && group.students.length > 0) {
                for (const student of group.students) {
                  if (student.topics && student.topics.length > 0) {
                    var finalScore = null;
                    if (type == 0) finalScore = this._getAvg(student.topics);
                    else if (type == 1)
                      finalScore = this._getSum(student.topics);
                    else if (type == 2) finalScore = student["calculatedScore"];

                    if (finalScore) {
                      var doc = await fb.db
                        .collection("schools/" + this.schoolId + "/lessons")
                        .doc(this.lessonId)
                        .collection("studentList")
                        .doc(student.id)
                        .get();
                      if (doc.exists) {
                        doc.ref.update({
                          scoreModifiedAt: new Date(),
                          finalScore: finalScore,
                        });
                      } else
                        doc.ref.set({
                          scoreModifiedAt: new Date(),
                          // earnedScore:finalScore, TODOX
                          finalScore: finalScore,
                          addedDate: new Date(),
                          studentRef:
                            student && student.ref ? student.ref : null,
                        });
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
    LessonInfo,
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    programId: {
      required: false,
    },
    groupId: {
      required: false,
    },
  },
  created() {
    // /schools/xUSN7smB3EcLwDYhs1Y9/departments/6xvVvEq1CzxW7vUx8Nnl/programs/xz0KhaYquJpyjT8oJL4h

    fb.db
      .collection("schools")
      .doc(this.schoolId)
      .onSnapshot((doc) => {
        let school = doc.data();
        school.id = doc.id;
        this.school = school;
      });

    fb.db
      .collection("schools")
      .doc(this.schoolId)
      .onSnapshot((doc) => {
        let school = doc.data();
        school.id = doc.id;
        this.school = school;
      });

    if (this.lessonId != null && this.lessonId != "") {
      this._initData();
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>


<style>
::placeholder {
  color: #bbb !important;
  font-size: 10pt;
}
.scorehead {
  width: 12%;
}
.score-table.form-control {
  height: calc(1.8em) !important;
  border-radius: 0rem;
}
.score-table {
  width: 100%;
  margin-bottom: 1rem;
  color: #000;
}
.alignRight {
  text-align: right;
}
.alignLeft {
  text-align: left;
}
.table td,
.table th {
  vertical-align: middle;
  border-top: 1px solid #e3e6f0;
}
.b3-collapsing-form-additional-icons {
  display: inline-block;
  height: 24px;
  margin-bottom: -12px;
  margin-top: -12px;
  padding: 12px;
}
.svg-icon {
  cursor: pointer;
  display: inline-block;
  fill: #80868b;
  /* rgba(0,0,0,0.38);  */
  -webkit-transition: fill 0.25s linear;
  transition: fill 0.25s linear;
  width: 24px;
}
.svg-icon:hover {
  fill: rgba(0, 0, 0, 0.78);
}
</style>
